export const TRADEVEST_CATALOG_DEFAULT_BROWSE_LIMIT = 50;
export const TRADEVEST_CATALOG_MAX_BROWSE_LIMIT = 100;
export const TRADEVEST_CATALOG_MAX_SEARCH_LIMIT = 50;
export const TRADEVEST_CATALOG_MIN_SEARCH_TERM_LENGTH = 2;
export const TRADEVEST_QUOTES_MAX_ISINS_PER_REQUEST = 60;
export const TRADEVEST_CATALOG_INITIAL_DIGIT = '0-9';
export const TRADEVEST_CATALOG_INITIAL_OTHER = 'other';
export const TRADEVEST_CATALOG_INITIALS = [
    TRADEVEST_CATALOG_INITIAL_DIGIT,
    ...Array.from({ length: 26 }, (_, i) => String.fromCharCode(97 + i)),
    TRADEVEST_CATALOG_INITIAL_OTHER,
];
//# sourceMappingURL=tradevest-catalog.constants.js.map